// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1hp8i","title":"AfterBackImages_title__1GH5s","images":"AfterBackImages_images__1_6pT"};